const initRelatedCardsSwiper = (root = document) => {
  if (!window.Swiper) return;

  root.querySelectorAll('.related-cards__swiper.swiper').forEach((container) => {
    if (container.classList.contains('swiper-initialized')) return;

    const slides = container.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    const sectionEl = container.closest('.related-cards');
    const nextEl = sectionEl?.querySelector('.related-cards__navigation__btn.next') ?? null;
    const prevEl = sectionEl?.querySelector('.related-cards__navigation__btn.prev') ?? null;

    // eslint-disable-next-line no-new
    new Swiper(container, {
      speed: 400,
      slidesPerView: 1,
      spaceBetween: 30,
      loop: slides.length > 1,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
    });
  });
};

initRelatedCardsSwiper();

document.addEventListener('shopify:section:load', (event) => {
  initRelatedCardsSwiper(event.target);
});


